'use client';

import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { DesignIcon } from '@monorepo/nova-icons';
import {
  IconButton,
  Tooltip,
  TooltipPlacement,
  useBreakpoints,
} from '@monorepo/nova-ui';
import { useYoutubeLiveStreamVideos } from '../../../api/queries/use-youtube-queries';

export const YoutubeLive: FunctionComponent = () => {
  const { data: youtubeLiveStream } = useYoutubeLiveStreamVideos();
  const { isMobile, isDesktop } = useBreakpoints();
  const { t } = useTranslation('hubCommon');

  const iconName = isMobile
    ? youtubeLiveStream?.live
      ? 'YoutubeMobileEnabled'
      : 'YoutubeMobileDisabled'
    : youtubeLiveStream?.live
      ? 'YoutubeLiveLogoEnabled'
      : 'YoutubeLiveLogoDisabled';

  if (!youtubeLiveStream?.enabled) {
    return null;
  }

  return (
    youtubeLiveStream?.enabled && (
      <Tooltip
        title={
          youtubeLiveStream?.live
            ? t('youtubeLiveBeginBroadcast')
            : t('youtubeLiveNotAvailable')
        }
        placement={TooltipPlacement.Bottom}
      >
        <span style={{ display: 'inline-flex' }}>
          <IconButton
            onClick={() => {
              if (youtubeLiveStream?.videoUrl) {
                window.open(youtubeLiveStream.videoUrl, '_blank');
              } else {
                console.error('No youtube live stream video url found');
              }
            }}
            aria-label={
              youtubeLiveStream?.live
                ? 'Youtube live - Click to disable'
                : 'Youtube live - Click to enable'
            }
            disabled={false}
            sx={{
              width: isMobile ? 28 : 80,
              height: isMobile ? 28 : 28,
              minWidth: 'unset',
              p: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginLeft: !isDesktop ? '16px' : '24px',
            }}
          >
            <DesignIcon
              iconName={iconName}
              useMuiSvgIcon={false}
              sx={{
                width: '100%',
                height: '100%',
                fontSize: 'inherit',
              }}
            />
          </IconButton>
        </span>
      </Tooltip>
    )
  );
};
